"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJWinScene = void 0;
const CGJGeneralMenuScene_1 = require("./CGJGeneralMenuScene");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
class CGJWinScene extends CGJGeneralMenuScene_1.CGJGeneralMenuScene {
    constructor() {
        super("CGJWinScene", false);
    }
    onCreate() {
        const w = Number(this.game.config.width);
        const h = Number(this.game.config.height);
        this.add.image(w * .75, h * .5, 'WinDrawing');
        for (let i = 0; i < 150; i++) {
            const x = w * .25;
            const angle = Math.random() * Math.PI * 2;
            const dist = Math.random() * 200;
            this.add.sprite(Math.cos(angle) * dist + x, Math.sin(angle) * dist + h / 2, 'Apple').setScale(2);
        }
        this.add.image(w * .25, h * .5, 'StoneHead2').setScale(4);
        this.inited = true;
        this.resize(w, h);
        return new KHMenuSpec_1.KHMenuSpec("", [
            this.addText(.5, .2, "You appeased Cyclus!\nTime has returned to normal."),
            this.addClickableOption(.5, .9, "Main Menu", () => {
                this.startScene("CGJMenuScene", null, true);
            }),
        ]);
    }
}
exports.CGJWinScene = CGJWinScene;
